// extracted by mini-css-extract-plugin
export default {"content":"PK-z","lookName":"QK-z","shopTheLookContainer":"RK-z","productContainer":"SK-z","imageContainer":"TK-z","mainImage":"UK-z"};